"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _MinxIcon = createIcon({
  displayName: "_MinxIcon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        d="m251.175 344.902c-15.664 0-31.329-.094-46.992.076-3.29.035-4.977-.713-6.058-4.1-9.585-30.042-19.315-60.038-29.172-89.992-1.001-3.044-.645-4.628 2.023-6.55 25.664-18.486 51.241-37.095 76.758-55.784 2.453-1.798 4.058-1.814 6.521-.01 25.783 18.888 51.632 37.688 77.563 56.373 2.327 1.678 2.853 3.131 1.999 5.73-9.939 30.281-19.854 60.571-29.621 90.908-.918 2.852-2.357 3.414-5.029 3.397-15.997-.099-31.995-.049-47.992-.048z"
        fill="currentColor"
      />
      <path
        d="m81.158 360.791h5.004c32.329 0 64.657.049 96.985-.069 3.509-.013 5.154.878 6.304 4.478 9.896 30.991 20.055 61.898 30.126 92.833.404 1.242.718 2.514 1.195 4.201-1.441.171-2.677.443-3.913.444-32.828.023-65.656-.002-98.484.057-2.743.005-4.47-.372-5.472-3.507-10.209-31.938-20.604-63.815-30.944-95.711-.2-.62-.368-1.248-.801-2.726z"
        fill="currentColor"
      />
      <path
        d="m420.871 361.117c-4.331 13.301-8.589 26.358-12.836 39.42-6.31 19.401-12.652 38.793-18.867 58.225-.783 2.448-1.482 4.007-4.57 3.997-33.304-.105-66.607-.067-99.91-.084-.78-.001-1.56-.191-2.925-.369 2.513-7.876 4.885-15.417 7.325-22.936 8.092-24.925 16.252-49.826 24.253-74.778.905-2.821 2.142-3.88 5.199-3.869 32.97.112 65.94.068 98.911.083.98.001 1.959.173 3.42.311z"
        fill="currentColor"
      />
      <path
        d="m62.463 303.498c-4.519-13.747-8.896-26.934-13.185-40.148-6.194-19.087-12.274-38.211-18.54-57.274-.828-2.521-.974-4.133 1.479-5.901 27.521-19.853 54.961-39.816 82.432-59.739.253-.184.618-.213 1.529-.508 10.893 33.512 21.784 67.021 32.747 100.749-28.83 20.946-57.448 41.74-86.462 62.821z"
        fill="currentColor"
      />
      <path
        d="m337.155 103.893c-12.396 9.027-24.196 17.632-36.01 26.219-15.603 11.342-31.235 22.643-46.801 34.035-2.063 1.51-3.604 2.317-6.104.488-26.978-19.739-54.042-39.359-81.096-58.996-.669-.486-1.478-.782-2.723-1.426 15.37-11.182 29.726-21.637 44.095-32.073 13.05-9.479 26.144-18.896 39.146-28.441 2.081-1.527 3.582-2.332 6.09-.498 27.512 20.127 55.113 40.134 83.403 60.692z"
        fill="currentColor"
      />
      <path
        d="m386.494 139.75c19.439 14.112 38.268 27.78 57.094 41.45 8.614 6.255 17.301 12.416 25.755 18.88 1.295.99 2.515 3.714 2.074 5.095-10.228 32.07-20.688 64.065-31.114 96.071-.19.585-.5 1.131-.938 2.104-13.7-9.934-27.148-19.667-40.578-29.427-13.991-10.167-28.008-20.3-41.874-30.636-1.331-.992-2.736-3.651-2.317-4.967 10.422-32.704 21.084-65.331 31.898-98.57z"
        fill="currentColor"
      />
      <path
        d="m372.915 129.904c-10.972 33.757-21.873 67.301-32.916 101.279-25.269-18.359-50.017-36.34-75.39-54.775 28.909-21.016 57.462-41.771 86.146-62.622 7.486 5.445 14.72 10.707 22.16 16.118z"
        fill="currentColor"
      />
      <path
        d="m205.36 360.961h92.402c-2.201 6.848-4.275 13.36-6.388 19.86-8.407 25.865-16.896 51.705-25.156 77.617-1.051 3.297-2.494 4.478-5.923 4.334-6.315-.266-12.658.098-18.97-.206-1.492-.071-3.804-1.449-4.228-2.728-10.741-32.428-21.282-64.923-31.842-97.411-.091-.285.04-.646.105-1.466z"
        fill="currentColor"
      />
      <path
        d="m154.121 256.671c9.645 29.699 19.055 58.677 28.652 88.231-2.158 0-3.623 0-5.088 0-32.322 0-64.646-.081-96.967.105-3.926.022-5.588-1.302-6.579-4.865-1.644-5.911-3.82-11.676-5.425-17.596-.366-1.351.156-3.803 1.157-4.537 27.777-20.369 55.668-40.582 84.25-61.338z"
        fill="currentColor"
      />
      <path
        d="m237.396 176.399c-25.039 18.193-49.65 36.077-74.886 54.413-2.38-7.353-4.586-14.184-6.803-21.011-8.25-25.418-16.44-50.855-24.841-76.224-1.021-3.084-.643-4.775 2.055-6.603 6.058-4.103 11.897-8.528 18.316-13.178 28.54 20.738 57.161 41.533 86.159 62.603z"
        fill="currentColor"
      />
      <path
        d="m319.951 344.567c9.437-29.067 18.835-58.019 28.414-87.527 9.354 6.802 18.334 13.343 27.324 19.87 18.431 13.38 36.829 26.805 55.34 40.072 2.605 1.867 3.309 3.441 2.11 6.561-2.255 5.87-4.094 11.913-5.845 17.959-.72 2.484-1.812 3.459-4.481 3.451-33.617-.088-67.234-.066-100.852-.084-.487 0-.976-.141-2.01-.302z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _MinxIcon;
